import React, { useEffect, useState } from "react";
import { manualPaymentAction, selectedCardFunc, setPaymentSteps, setQuantity } from "../../actions/stripe";
import { useDispatch, useSelector } from "react-redux";
import { CURRENCY, GOLD_QUANTITY_LIST, PRODUCT_BULLION_TYPE, PRODUCT_GOLD_TYPE, SUBSCRIPTION_MODULE_TYPE } from "../../constants";
import { Controller, useForm } from "react-hook-form";
import debounce from "debounce";
import Currency from "../currency";
import CurrencyFormat from "../currencyFormat/currencyFormat";

export default function ProductQuantity() {
  const dispatch = useDispatch()
  const { stripePlans, isOverrideProduct, stripeType, savedbankInfoDetails, isManualPayment } = useSelector(state => state.stripe);
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    watch,
  } = useForm({
    defaultValues: {
      saveInfo: 'true',
      quantity: GOLD_QUANTITY_LIST[0],
    },
    mode: 'onChange',
  });
  const quantityWatch = watch("quantity")
  const amonutWatch = watch("baseAmountRate")

  const onApplyQty = data => {
    setValue('quantity', data);
    trigger("quantity")
    dispatch(setQuantity(data))
  };

  const quantityOption = () => {
    if ([CURRENCY.INR, CURRENCY.CNY].includes(savedbankInfoDetails?.currency?.value)) {
      return GOLD_QUANTITY_LIST.slice(0, 1);
    } else {
      return GOLD_QUANTITY_LIST.slice(0, 5);
    }
  };

  const imagePaths = {
    usd: ('assets/img/usd.png'),
    sgd: ('assets/img/sgd.png'),
    inr: ('assets/img/inr.png'),
    pkr: ('assets/img/pkr.png'),
    lkr: ('assets/img/lkr.png'),
    bdt: ('assets/img/bdt.png'),
    cny: ('assets/img/cny.png'),
    // Add more values as needed
  };

  useEffect(() => {
    setValue("baseAmountRate", isManualPayment)
  }, [setValue, isManualPayment])


  const imagePath =
    imagePaths[stripePlans?.currency?.value] || ('assets/img/usd.png');

  const handleInputChange = value => {
    dispatch(manualPaymentAction(value ? value : 0));
  };

  const debouncedHandleInputChange = debounce(handleInputChange, 500);

  const handleInputStripeAmount = e => {
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
    debouncedHandleInputChange(e.target.value.length > 0 ? e.target.value : 0); // Call the debounced function
  };

  return (
    <>
      <div className="container">
        <div className="row buyProductSectionBg">
          <div className="col-md-12">
            {isOverrideProduct &&
              <div className="quantitySection">
                <h5 className="m-0">Select quantity</h5>
                <div className="selectQuantitySection">
                  {quantityOption().map((info, index) => (
                    <div onClick={() => onApplyQty(info)} className={`${info.value === getValues("quantity").value ? "active" : ""} selectQuantity`}>
                      <p>{info.label}</p>
                      <span> {stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.GRAM ? "Gram" : "Kilogram"}</span>
                    </div>
                  ))}
                </div>

              </div>
            }

            <div className="quantitySection amountQuantitySection">
              <h5 className="m-0">{parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL || parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS ? "Enter amount" : "Amount"}</h5>
              {(parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL || parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS) ? (
                <>
                  <div className="selectedAmountSectionInput">
                    <Controller
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <input
                          maxLength={20}
                          type="div"
                          className="form-control-no-border"
                          placeholder="Required"
                          value={value?.toString()}
                          onInput={e => {
                            onChange(e);
                            handleInputStripeAmount(e);
                          }}
                        />
                      )}
                      name="baseAmountRate"
                      rules={{
                        required: {
                          value: true,
                          message: 'Enter amount',
                        },
                      }}
                    />

                    <div className="selectorCountry">
                      <img src={imagePath} alt="country" />
                      <p className="m-0">{stripePlans?.currency?.value}</p>
                    </div>
                  </div>
                  {errors && errors.baseAmountRate && (
                    <span className="errorMessage ">
                      {errors?.baseAmountRate?.message}
                    </span>
                  )}
                  {!errors.baseAmountRate && amonutWatch < 100 &&
                    <span className="errorMessage ">
                      Minimum value must be at least 100
                    </span>
                  }
                </>
              )
                : (
                  <div className="selectedAmountSection">
                    <p className="m-0 selectedQuantityText">
                      <Currency currency={stripePlans?.currency?.value} />
                      <CurrencyFormat
                        currency={stripePlans?.currency?.value}
                        value={parseFloat(stripePlans?.price) * parseFloat(quantityWatch?.value)}
                        decimal={2}
                      /></p>
                    <div className="selectorCountry">
                      <img src={imagePath} alt="country" />
                      <p className="m-0">{stripePlans?.currency?.value}</p>
                    </div>
                  </div>
                )}
              <h6 className="importantNote">
                Important: This is not the final amount for the transaction.
              </h6>
            </div>

            {/* <div className="eligibleRewardSection">
              <h3 className="eligibleReward">Eligible for the Reward</h3>
              <div className="goldBonus">
                <h2 className="m-0">50g Gold Bonus</h2>
                <h6 className="m-0">Gold</h6>
              </div>
              <p className="eligibleRewardDesc m-0">
                Add more 10 gram more gold and earn 60 gram gold bonus
              </p>
            </div> */}
          </div>
        </div>
      </div >
    </>
  );
}
